import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';
import { EquipmentGridComponent } from '../Equipment/EquipmentGrid.component';

@Component({
  selector: 'my-paperworkonlymovelineitem-grid',
  templateUrl: './PaperworkOnlyMoveLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => PaperworkOnlyMoveLineItemGridComponent)}]
})
export class PaperworkOnlyMoveLineItemGridComponent extends BaseGridComponent {
    lineItems: ent.PaperworkOnlyMoveLineItem[] = [];
    lineItem: ent.PaperworkOnlyMoveLineItem;
    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();
    @ViewChild(EquipmentGridComponent) public EquipmentGridComponent: EquipmentGridComponent;

    cols: any[];
    displayEquipmentDialog: boolean;
    suppressionReasons: ent.SuppressionReason[] = [];

    suppressionReasonSelectItems: SelectItem[] = [];


    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, 
      private customerService: serv.CustomerService, private router: Router, private equipmentService: serv.EquipmentService) {
        super();
    }

        
   

    ngOnInit(): void {
       
        this.load();
    }

    public load(){
      this.domainDataService.getSuppressionReasons({IncludeInactive: false}).subscribe(items=> {
        items.forEach(y=> this.suppressionReasons.push(y));

        this.suppressionReasonSelectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.suppressionReasonSelectItems.push({label:y.FullName, value:y.ID}));
      });
        
    }
    
    onAddLineItemClick(event: any){
        if (!this.lineItems){this.lineItems = []}
        var newLineItem = new ent.PaperworkOnlyMoveLineItem();
        newLineItem.LostFound = false;

        this.lineItems = [...this.lineItems, newLineItem];
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    onDeleteClick(event: any, lineItem: ent.PaperworkOnlyMoveLineItem){
        this.lineItems = _.remove(this.lineItems, x=>x !== lineItem);
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    suppressionReasonChange(event: any, lineItem: ent.PaperworkOnlyMoveLineItem){
      var sr = this.suppressionReasons.filter(x=>x.ID == event)[0];
      if (!lineItem.SuppressionReason || lineItem.SuppressionReason.ID != sr.ID){
          lineItem.SuppressionReason = sr;
          lineItem.SuppressionReasonID = sr.ID;
      }
      
    }

    selectedCustomerNumbersChanged_From(customerNumbers: string[], lineItem: ent.PaperworkOnlyMoveLineItem){
      if (customerNumbers && customerNumbers.length > 0){
          var filter: filters.CustomerFilter = {CustomerNumber: customerNumbers[customerNumbers.length - 1]};
          this.customerService.getCustomers(filter).subscribe(x=>
          {
              if (x && x.length > 0){
                  lineItem.FromCustomerNumber = x[0].CustomerNumber;
                  lineItem.FromCustomer = x[0];
              }
              else{
                  lineItem.FromCustomerNumber = "";
                  lineItem.FromCustomer = {};
              }
              
          });
      }
      else {
        lineItem.FromCustomerNumber = "";
        lineItem.FromCustomer = {};
      }

      lineItem.SerialNumber = '';
      
    }

    selectedCustomerNumbersChanged_To(customerNumbers: string[], lineItem: ent.PaperworkOnlyMoveLineItem){
      if (customerNumbers && customerNumbers.length > 0){
          var filter: filters.CustomerFilter = {CustomerNumber: customerNumbers[customerNumbers.length - 1]};
          this.customerService.getCustomers(filter).subscribe(x=>
          {
              if (x && x.length > 0){
                  lineItem.ToCustomerNumber = x[0].CustomerNumber;
                  lineItem.ToCustomer = x[0];
              }
              else{
                  lineItem.ToCustomerNumber = "";
                  lineItem.ToCustomer = {};
              }
              
          });
      }
      else {
        lineItem.ToCustomerNumber = "";
        lineItem.ToCustomer = {};
      }
      
    }

    onEquipmentSearchClick(event: any, lineItem: ent.PaperworkOnlyMoveLineItem){
      
      this.lineItem = lineItem;
      this.displayEquipmentDialog = true;
      var filter: filters.EquipmentFilter = {CustomerNumber: lineItem.FromCustomerNumber, 
          IncludeRelatedEquipmentRequests: false};

      let selectedEquipmentNumbers: string[] = [];
      if (lineItem.SerialNumber) {
        selectedEquipmentNumbers = lineItem.SerialNumber.split(',');
      }
      this.EquipmentGridComponent.load(filter, selectedEquipmentNumbers);

    }

    disableAddEquipmentFromInventoryOK(): boolean {
        return this.EquipmentGridComponent.selectedRecords.length == 0;
    }

    onAddEquipmentFromInventoryOKClick(event: any){
        this.displayEquipmentDialog = false;
        
        this.lineItem.SerialNumber = this.EquipmentGridComponent.selectedRecords.map(x=> {
          return x.EquipmentNumber;
        }).join(",");
    }

    enableEquipmentLookup(lineItem: ent.PaperworkOnlyMoveLineItem){
      var val = lineItem.FromCustomer 
        && lineItem.FromCustomer.CustomerNumber
        && lineItem.FromCustomer.CustomerNumber != '' 
        && lineItem.LostFound === false;
      return val;
    }

    suppressCustomerChange(checked: any, lineItem: ent.PaperworkOnlyMoveLineItem){
      if (checked){
        this.EquipmentGridComponent.blockComponent.blocked = true;
        var filter: filters.EquipmentFilter = {CustomerNumber: lineItem.FromCustomerNumber, 
            IncludeRelatedEquipmentRequests: false};
        this.equipmentService.getEquipments(filter).subscribe(records=> {
            lineItem.SerialNumber = records.map(x=> {
              return x.EquipmentNumber;
            }).join(",");
            this.EquipmentGridComponent.blockComponent.blocked = false;
        }, err => {
          this.EquipmentGridComponent.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.EquipmentGridComponent.blockComponent.blocked = false;
        }); 
      }
      
    }
    

    onHide(){
      this.displayEquipmentDialog = false;
    }

}